import { IShader, ShaderBase } from '../shader';
import { Material, Scene, PBRMetallicRoughnessMaterial } from '@babylonjs/core';

export class ShaderLiftedFrame extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = 'bed1_icon.png';
    public text: string = 'liftedFrame';
    public key: string = 'ShaderLiftedFrame';

    public getMaterial(scene: any): Material {
        return new Material('', scene);
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return material;
    }
}
